<script lang="ts" setup>
const { isSpotlightOpened } = useOverlays()
const listsStore = useListsStore()
const route = useRoute()
const { toggleModal } = useOverlays()
const { routeNameWithoutLocale } = useNavigation()
const overlays = useOverlays()
const userStore = useUserStore()

const list = computed(() => {
  return listsStore.lists.find((list) => {
    return list.id === Number.parseInt(`${route?.params.listId}`)
  })
})

function handleEmailVerify() {
  if (routeNameWithoutLocale.value === 'auth-login' || routeNameWithoutLocale.value === 'auth-verification') {
    toggleModal({
      data: { currentView: 'login' },
      opened: false,
      preserve: true,
      type: 'auth',
    })

    return
  }

  if (userStore?.user) {
    if (!userStore?.user?.emailVerified) {
      toggleModal({
        closable: false,
        data: { currentView: 'verifyEmail' },
        opened: true,
        preserve: true,
        type: 'auth',
      })
    }
  }
}

onMounted(handleEmailVerify)
</script>

<template>
  <ClientOnly>
    <UModals />

    <ModalAuth
      v-if="overlays.modals.auth.opened"
      v-model="overlays.modals.auth.opened"
    />

    <ModalSubscription
      v-if="overlays.modals.subscription.opened"
      v-model="overlays.modals.subscription.opened"
    />

    <ModalListCreate
      v-if="overlays.modals.list.opened"
      v-model="overlays.modals.list.opened"
    />

    <ModalListEnrichment
      v-if="overlays.modals.listEnrichment.opened"
      v-model="overlays.modals.listEnrichment.opened"
    />

    <UNotifications :ui="{ position: 'bottom-[100px]' }" />
  </ClientOnly>

  <template v-if="!isSpotlightOpened">
    <USlideovers />

    <SlideoverCompany
      v-if="overlays.slideovers.company.opened"
      v-model="overlays.slideovers.company.opened"
      :list="list"
    />
  </template>
</template>
